module.exports = __webpack_public_path__ + "static/media/justify_white.37e8a377.svg";